
  export const environment = {
    production: true,
    version: '(env.dev)',
    apiUrl: 'https://fra32.propergate.app/api',
    apiNgUrl: 'undefined',
    appUrl: 'https://fra32.propergate.app',
    appNgUrl: 'https://fra322.propergate.app',
    socketUrl: '',
    socketPath: '/api/socket.io',
    defaultTokenKey: 'token',
    defaultLanguage: 'en',
    enableFloorEditor: true,
    clientShortname: 'PORFRA',
    procoreIntegrationUrl: 'undefined',
    gcpApiKey: 'AIzaSyCb2rZE12HyiwiRXm0z3Ilo-eowKy5zauE',
    gcpProjectId: 'azure-migration-285408',
    clientLogoUrl: 'undefined'
  };